import 'css-chunksrc/client/scenes/preferences/calendar/calendarHolidays/selectList/styles.scss';export default {
  "calendarSelection": "_calendarSelection_j9r82_1",
  "input": "_input_j9r82_5",
  "selection": "_selection_j9r82_18",
  "placeholder": "_placeholder_j9r82_24",
  "list": "_list_j9r82_28",
  "calendar": "_calendar_j9r82_1",
  "iconBox": "_iconBox_j9r82_59",
  "icon": "_icon_j9r82_59",
  "opened": "_opened_j9r82_69",
  "selected": "_selected_j9r82_77",
  "selectedCalendarIcon": "_selectedCalendarIcon_j9r82_81",
  "disabled": "_disabled_j9r82_87",
  "clear": "_clear_j9r82_93"
};